import { sagaCreator } from '@adrias-online/steiner';

import { createSagas } from '../../../helpers/portaleModuleHelper';
import { actions, actionTypes } from '../actions/portaliRedirects';
import { selectors, DEFAULT_STATE } from '../reducers/portaliRedirects';
import api from '../apis/portaliRedirects';

const sagas = createSagas(
    'portaliRedirects',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Redirect'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
